import React from 'react';
import ImagesLogin from '../components/imagesLogin';
import FormLogin from '../components2/formLogin';

function Login () {
    return (
        <div className="flex flex-wrap">
            <div className="h-full lg:h-screen lg:w-3/5 bg-custom-cyan">
                <ImagesLogin /> 
            </div>
            <div className="w-full lg:w-2/5">
                <FormLogin />
            </div>
        </div>
    )
}

export default Login;